import { render, staticRenderFns } from "./EmpresaRegimes.vue?vue&type=template&id=c73c39cc&scoped=true"
import script from "./EmpresaRegimes.vue?vue&type=script&lang=js"
export * from "./EmpresaRegimes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73c39cc",
  null
  
)

export default component.exports